module.exports = __webpack_public_path__ + "static/media/questionMark.9551e4cf.svg";